import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Button from '../../../components/button/Button';
import Toast from '../../../components/toast/Toast';

class SelectPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      module: this.props.defaultSelectValue,
      modules: this.props.modules
    };

    this.onSelect = this.onSelect.bind(this);
  }

  onConfirm() {
    const { title } = this.props;
    const loading = Toast.loading(`正在${title}${this.state.module}`);
    this.props.onConfirm(this.state.module).then(() => {
      Toast.success(`${title}成功`);
    }).catch((error) => {
      Toast.fail(error);
    }).then(() => {
      loading.destroy();
    });
  }

  onSelect(e) {
    this.setState({
      module: e.target.value
    });
  }

  render() {
    const { title, label = '选择设备：' } = this.props;

    return (
      <div>
        <h4 className="popup-title">{title}</h4>
        {
          this.props.slot ? <this.props.slot store={this.props.store} /> : []
        }
        <div style={{ display: 'flex' }}>
          <span>{label}</span>
          <select style={{ flex: 1, border: '1px solid #ccc', background: '#fff' }} onChange={this.onSelect} defaultValue={this.state.module}>
            {
              this.state.modules.map(item => (
                <option key={item} value={item}>{item}</option>
              ))
            }
          </select>
        </div>
        <div style={{ textAlign: 'center' }}>
          <Button type="primary" onClick={() => this.onConfirm()}>{title}</Button>
        </div>
      </div>
    );
  }
}

export default observer(SelectPopup);
